import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';

interface VehicleOption {
    label: string,
    value: number,
}

@IonicPage()
@Component({
    selector: 'page-sample',
    templateUrl: 'sample.html',
})
export class SamplePage {

    vehicleOptions: VehicleOption[] = [
        { value: 1, label: 'Vehicle' }
    ];

    constructor(
        public navCtrl: NavController,
        public navParams: NavParams
    ) {}
}



// WEBPACK FOOTER //
// ./src/pages/sample/sample.ts